import { FC } from "react";

import Title from "@components/Title";

const TitleBold: FC<{ text: string }> = ({ text }) => {
  return (
    <Title>
      <span className="bold">{text}</span>
    </Title>
  );
};

export default TitleBold;
